// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"f6523bef","396":"ca88d0a0","854":"4fa2fc92","911":"f6523bef"}[chunkId] + ".chunk.css";
};